// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalUpdate_form__214eO"};